// Defaults to norway
const COUNTRY = process.env.GATSBY_COUNTRY === 'sweden' ? 'sweden' : 'norway';

const DEPLOYMENT_URL = {
  norway: 'https://www.drdropin.no',
  sweden: 'https://www.drdropin.se',
}[COUNTRY];

export default DEPLOYMENT_URL;
